import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";

import App from "./containers/App";
import indexReducer from "./reducers";

const logger = createLogger();
const store = createStore(
  combineReducers(indexReducer),
  composeWithDevTools(applyMiddleware(thunk))
);

if (window.location.port !== "3000") {
  window.Raven.config(
    "https://c447507fa66446668395aee03ff728ef@sentry.io/276133",
    { release: "1.4" }
  ).install();
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./index.js